import { render, staticRenderFns } from "./brandActivities.vue?vue&type=template&id=5db6c9c2&scoped=true&"
import script from "./brandActivities.vue?vue&type=script&lang=js&"
export * from "./brandActivities.vue?vue&type=script&lang=js&"
import style0 from "./brandActivities.vue?vue&type=style&index=0&id=5db6c9c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db6c9c2",
  null
  
)

export default component.exports